// Shared Header (Results/Shortlist variant)
// Does NOT fetch CSRF or shortlist data. Instead exposes a method
// for the host app to push shortlist summary data in.
//
// Usage from Nuxt or any consuming app:
//   window.sharedHeader.updateShortlist({ id: '...', accommodationGiataIds: [...], maxLength: 100 });

import { initMenuControllers, initTrustElements, ShortlistUIUpdater } from './shared-header-core';
import type { ShortlistSummary } from './shared-header-core';

interface SharedHeaderAPI {
  updateShortlist: (summary: ShortlistSummary) => void;
}

declare global {
  interface Window {
    sharedHeader: SharedHeaderAPI;
  }
}

let updater: ShortlistUIUpdater | null = null;

function getUpdater(): ShortlistUIUpdater | null {
  if (updater) return updater;
  const headerEl = document.querySelector<HTMLElement>('[data-header]');
  if (!headerEl) return null;
  updater = new ShortlistUIUpdater(headerEl);
  return updater;
}

// Expose the API immediately so the host app can call it
// even before DOMContentLoaded (calls will lazily find the header).
window.sharedHeader = {
  updateShortlist(summary: ShortlistSummary): void {
    const u = getUpdater();
    if (u) u.update(summary.id, summary.accommodationGiataIds.length);
  },
};

// Init menu controllers and Trust_Element modals once the DOM is ready.
document.addEventListener('DOMContentLoaded', () => {
  const headerEl = document.querySelector<HTMLElement>('[data-header]');
  if (!headerEl) return;
  initMenuControllers(headerEl);
  initTrustElements(headerEl);
});
